/*
 * @license
 * Copyright© Celligence International, LLC - 2023
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */

import React, { useState} from "react";
import { Navbar } from "react-bootstrap";
import Classes from "./index.css";
import {isMobileOrTablet } from "../Utils/index.js";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu/index.js";

const HeaderNavbar = () => {
  const [navbar, setNavbar] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
  let prevScrollPos = window.scrollY;

  window.onscroll = function () {
    const currentScrollPos = window.scrollY;
    const menuNavbar = document.getElementById("menuNavbar");

    if (currentScrollPos === 0) {
      menuNavbar.classList.remove("navbarTransition");
      setNavbar(false);
    } else {
      if (prevScrollPos > currentScrollPos) {
        // Perform your desired actions for scrolling up here
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        // Perform your desired actions for scrolling down here
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar.classList.add("navbarTransition");
        }
      }
    }

    prevScrollPos = currentScrollPos;
  };

  return (
    <>
      <div>
          <Navbar
            id="menuNavbar"
            collapseOnSelect
            expand="lg"
            fixed="top"
            bg="dark"
            variant="dark"
            className={navbar ? "navbar active" : "navbar"}
          >
            <div className="navcont">
              <Navbar.Brand className="ps-3">
                <div className="nav-logo">
                  <div>
                    <a
                      href={"https://www.swmc.com/"}
                      target="_blank"
                      rel="noopener noreferrer"
                      title={"SWMC-Logo"}
                    >
                      <img
                        src={
                          "https://resources.swmc.com/swmc-images/sunwest-trust-white-logo.png"
                        }
                        className="main_logo"
                        alt={"SWMC logo"}
                      />
                    </a>
                  </div>
                 
                </div>
              </Navbar.Brand>
            </div>
            <div className="desktop-AccessibilityMenu-show">
            <UserWayAccessibilityMenu color="whiteS" width={40} height={40}/>
          </div>
          </Navbar>
     
          <div className="mobile-AccessibilityMenu-show">
        <UserWayAccessibilityMenu color="white" width={40} height={40}/>
        </div>
      </div>
    </>
  );
};

export default HeaderNavbar;
